module.exports = __webpack_public_path__ + "static/subset-UniNeueBlack-7ae354e1b56f891226d22b377f6ca2dd.woff";